<template>
  <div class="tip_template">
    <el-dialog :visible.sync="dialogVisible" title="提词器模版" width="800px">
      <div v-if="type == 2">
        <h3>
          一、基于文生图（Text-to-Image）模型，通过提示词工程生成商品图实例。
        </h3>

        <h4>图片实例1</h4>
        <div>
          <img
            src="https://image.soole.com.cn/e1359f27-467a-4a11-8b1e-8f551f3f712f.png"
            alt=""
            width="350"
            height="750"
          />
          <p>
            提示词实例1：电商商品用图。主体为一只透明玻璃碗，碗中摆放着浅棕色的十夜悠食食叶草鸡蛋，其中一颗鸡蛋蛋壳破开，露出橙黄色饱满的蛋黄
            。背景是温馨的木质桌面，增添自然质朴的氛围。上方配有棕色底白色字的标签，内容为
            “ 蛋香浓郁 健康营养 ” ，下方是白色字体的产品名称 “十夜悠食
            食叶草鸡蛋”。在画面的上方区域，有浅米色背景的发货说明板块，文字内容为
            “因物流配送限制，海南三沙、青海玉树地区、新疆、西藏地区暂不销售”
            。整体画面清晰简洁，色彩搭配和谐，突出商品特点与关键信息，符合电商平台商品展示的逻辑与需求。
          </p>
        </div>
        <div>
          <h4>图片实例2</h4>
          <img
            src="https://image.soole.com.cn/82b4b25f-becc-45ad-9998-0d02d5db2e42.png"
            alt=""
            width="350"
            height="750"
          />
          <p>
            提示词实例2：电商商品用图：用棚拍柔光，深色木纹背景上，白色瓷勺盛着饱满桑葚干，表面带自然褶皱、黑亮哑光质感，周围散落同款果干，上方叠加“桑葚果干
            原果风味 酸甜美味”
            清晰字体；下方浅粉色信息区写“产品名称：凉山缘果・桑葚果干”
            。整体排版规整，质感写实，还原电商平台实拍商品图逻辑.
          </p>
        </div>
        <div>
          <h4>图片实例3</h4>
          <img
            src="https://image.soole.com.cn/ce1e27fe-a325-4643-a728-7332e53b8f3b.png"
            alt=""
            width="350"
            height="750"
          />
          <p>
            电商商品用图
            。以柔和浅粉色为整体底色，构建桑果干多元食用场景展示：画面中心设置创意泡饮区，透明玻璃杯一分为二，左半杯是
            PH5.5 - 7 的红色桑果饮，右半杯是 PH7 - 8.5
            的紫色桑果饮，杯口点缀饱满黑桑果干，标注对应酸碱度数值，呈现天然花青素变色魅力；右侧设置多场景展示区，其一为养生茶歇场景，白瓷盘盛着黑桑果干，旁侧透明玻璃杯泡好深色桑果饮，搭配精致小茶点，营造悠闲下午茶氛围；其二为烘焙点缀场景，桑果干撒在刚出炉的酸奶蛋糕、燕麦饼干表面，凸显烘焙食材用途；其三为
            DIY
            果酱场景，玻璃罐里桑果干与蜂蜜、柠檬混合熬煮，呈现自制果酱的过程与成果
            。下方白色步骤框详细罗列基础泡饮流程 “取桑果干→40 -
            60℃温水泡→稍等饮用→吃果肉” ；红底白字突出说明
            “自然花青素在不同酸碱度条件下呈现不同颜色，不忧桑桑果干自然原色，无人工色素添加，安心食用”
            ；底部紫色营养成分表，清晰列出每 100
            克桑果干的能量、蛋白质、脂肪、碳水化合物、钠等数据及营养素参考值 %
            。整体排版规整，百搭的产品卖点。
          </p>
        </div>
        <div>
          <h4>图片实例4</h4>
          <img
            src="https://image.soole.com.cn/089b6cb5-a227-4a4e-bec6-8f91b88a6be0.png"
            alt=""
            width="350"
            height="750"
          />
          <p>
            提示词实例4：
            电商商品用图：画面以简洁白底呈现，中心主体是一瓶“川渝大团结巴蜀小榨
            0.9L”菜籽油，透明瓶身可见棕褐色油体，红色瓶盖、黄色标签清晰，标签印“大团结
            菜籽油”字样 。
          </p>
        </div>
      </div>
      <div v-if="type == 1" class="txt">
        <h3>文生文提示词模板：</h3>
        <br />
        <p>【角色】你是一名顶级的电商文案专家，擅长撰写高转化率的商品描述。</p>
        <p>【任务】为以下商品创作一份吸引人的电商平台商品描述。</p>
        <p>
          <br />
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;【商品基础信息】
          -商品名称：{商品名称} -<br />
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp;核心卖点：{卖点1}、{卖点2}、{卖点3}<br />
          &nbsp; &nbsp; &nbsp; &nbsp;
        </p>
        <p>
          &nbsp; &nbsp; &nbsp; &nbsp;（如：100%新疆棉、透气性强、无感标签） -
          目标人群：{目标人群}
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;
          &nbsp;（如：追求舒适感的都市白领、注重品质的新手妈妈）
        </p>
        <p><br /></p>
        <p><br /></p>
        <p>【输出要求】</p>
        <p>
          &nbsp; &nbsp; 1.**标题：**
          生成一个包含核心关键词、限20字以内的吸睛标题。<br />&nbsp; &nbsp; 2.
          **卖点bullet points：**
          列出3-4条突出商品优势的要点，前带图标（✨/✅/🌟）。<br />&nbsp; &nbsp;
          3.**详细描述：**
          写一段生动的情景化描述，融入使用场景，激发用户对美好生活的想象。语言要口语化、有感染力。<br />&nbsp;
          &nbsp; 4. **规格参数：**
          以表格形式清晰列出：颜色、尺寸、材质、重量等关键规格。<br />
          &nbsp; &nbsp; &nbsp; &nbsp;
        </p>
        <p><br /></p>
        <p>【风格与禁忌】 -</p>
        <p>&nbsp; &nbsp;**风格：** 热情专业，像朋友推荐一样可信赖。 -</p>
        <p>
          &nbsp;
          &nbsp;**禁忌：**禁止使用“最好”、“第一”等《广告法》违禁词，可用“高品质”、“高性价比”等替代。<br />
          &nbsp; &nbsp; &nbsp; &nbsp;
        </p>
        <p><br /></p>
        <p><br /></p>
        <p>【示例模板牛肉干】：</p>
        <p>
          &nbsp;
          &nbsp;【角色】你是一名顶级的电商文案专家，擅长撰写高转化率的商品描述。
        </p>
        <p>&nbsp; &nbsp;【任务】为以下商品创作一份吸引人的电商平台商品描述。</p>
        <p>&nbsp; &nbsp;【商品基础信息】</p>
        <p>&nbsp; &nbsp; &nbsp; &nbsp;商品名称：内蒙古风干牛肉干</p>
        <p>
          &nbsp; &nbsp; &nbsp;
          &nbsp;核心卖点：内蒙古草原黄牛后腿肉、传统工艺自然风干、0添加防腐剂、独立包装便携卫生<br />
        </p>
        <p>
          &nbsp; &nbsp; &nbsp;
          &nbsp;目标人群：户外运动爱好者、上班族零食需求、注重健康饮食的家庭
        </p>
        <p>&nbsp; &nbsp;【输出要求】</p>
        <p>
          &nbsp; &nbsp; &nbsp; &nbsp;标题：
          生成一个包含核心关键词、限20字以内的吸睛标题。
        </p>
        <p>&nbsp; &nbsp; &nbsp; &nbsp;卖点 ：列出3-4条突出商品优势的要点，</p>
        <p>
          &nbsp; &nbsp; &nbsp; &nbsp;详细描述：
          写一段生动的情景化描述，融入使用场景，激发用户对美好生活的想象。语言要口语化、有感染力。
        </p>
        <p>
          &nbsp; &nbsp; &nbsp; &nbsp;规格参数：
          以表格形式清晰列出：颜色、尺寸、材质、重量等关键规格。
        </p>
        <p><br /></p>
        <p><br /></p>
        <p>使用技巧与最佳实践：</p>
        <p>
          <br />
          &nbsp; &nbsp; &nbsp;
          &nbsp;&nbsp;1.填充变量：将括号中的内容替换为您的具体商品信息，信息越详细，生成结果越精准。<br />
          &nbsp; &nbsp; &nbsp; &nbsp;<br />
          &nbsp; &nbsp; &nbsp;
          &nbsp;&nbsp;2.迭代优化：如果第一次生成不满意，可以进一步指令，如：“更夸张一些”、“更简洁一点”、“突出‘送礼’这个场景”。<br />
          &nbsp; &nbsp; &nbsp; &nbsp;<br />
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;3. 结合产品知识： 在
          【商品基础信息】<br />
          &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp;部分填入尽可能多的产品细节，模型知道的越多，写得越好。<br />
          &nbsp; &nbsp; &nbsp; &nbsp;
        </p>
      </div>
      <div v-if="type == 3" class="txt">
        <h3>视频主题：【商品名称】诱人动态效果视频</h3>
        <p>提示词：</p>
        <p>
          一段12秒的快速剪辑视频，极致凸显商品名称的诱人质感。背景是纯色或大理石台面，灯光明亮以突出产品。
        </p>
        <p>【镜头序列】</p>
        <p>
          1. **“食欲”开场：**
          产品被缓缓切开或打开，展示内部诱人质地（如：切开牛肉干展示内部的纤维纹理；冰淇淋勺挖起时拉丝；咖啡液倒入杯中与牛奶融合的瞬间）。
        </p>
        <p>
          2. **动态诱惑：**
          展示产品的动态效果（如：气泡水倒入杯中时丰富的气泡翻涌；酱汁淋在食物上的特写；口红划过手臂展示顺滑的显色度）。
        </p>
        <p>
          3. **成分强调：**
          新鲜原料（如：咖啡豆、香草荚、水果颗粒）飞入画面，环绕产品，强调天然成分。
        </p>
        <p>
          4. **欢快收尾：**
          镜头拉远，展示完整的产品包装，画面充满活力，让人感觉美味、清爽或愉悦。
        </p>
        <p>技术参数：</p>
        <p>- **画幅：** 1:1 (方形，适用于电商主图) 或 9:16</p>
        <p>- **风格：** 食欲感、干净、明亮、色彩饱和</p>
        <p>- **运镜：** 快速切镜、极致的慢动作特写</p>
        <p>- **渲染：** 逼真，突出食物的光泽和液体的流动感</p>
        <p>使用指南与最佳实践：</p>
        <p>
          1. 填充变量： 将 括号 中的内容替换为您的具体商品信息，如 商品名称 ->
          “内蒙古风干牛肉干”，目标人群 -> “都市年轻人”。
        </p>
        <p>2. 迭代生成： AI生成具有随机性。如果第一次效果不理想，可以：</p>
        <p>更具体： 增加更详细的描述（如“背景是浅灰色磨砂质感”）。</p>
        <p>换风格： 修改“风格”参数（如将“电影感”改为“动画风格”）。</p>
        <p>改运镜： 调整“运镜”指令（如“无人机俯冲镜头”）。</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: [Number, String],
    },
  },
  data() {
    return {
      dialogVisible: false,
    };
  },
  methods: {
    open() {
      this.dialogVisible = true;
    },
  },
};
</script>

<style scoped lang="scss">
div {
  text-align: center;
}
.txt {
  text-align-last: left;
}
</style>
